'use strict';

module.exports = '3.26.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 129
// module chunks = 483